import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimburtInfoDeductApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimburt-info-deduct'
  }

}